import { render, staticRenderFns } from "./EvalMyEvaluations.vue?vue&type=template&id=12a503da"
import script from "./EvalMyEvaluations.vue?vue&type=script&lang=js"
export * from "./EvalMyEvaluations.vue?vue&type=script&lang=js"
import style0 from "./EvalMyEvaluations.vue?vue&type=style&index=0&id=12a503da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports